import { render } from "./LoginRegist.vue?vue&type=template&id=611d5478"
import script from "./LoginRegist.vue?vue&type=script&lang=js"
export * from "./LoginRegist.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__